import { VEHICLE_WARRANTY_DATA } from '../actions';

const INIT_STATE = {
    id: null,
    estado: null,
    tramite_voluntario: null,
    peritaje: null,
    gestiongmv: null,

    calculator: {},
};

const warrantyReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case VEHICLE_WARRANTY_DATA:
            return { ...state, ...action.payload };
        default:
            return state;
    }
};

export default warrantyReducer;
